import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import type { HubTemplate } from '@/api/hooks/useAttestations';

interface ImportTemplateConfirmationModalProps {
  template: HubTemplate | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (template: HubTemplate) => void;
  isPending?: boolean;
}

export function ImportTemplateConfirmationModal({
  template,
  open,
  onOpenChange,
  onConfirm,
  isPending,
}: ImportTemplateConfirmationModalProps) {
  if (!template) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Import Assessment Template</DialogTitle>
        </DialogHeader>

        <div className="space-y-4 py-2">
          <div className="rounded-md border border-border-subtle bg-bg-surface p-3 space-y-1">
            <p className="text-xs text-text-muted font-medium uppercase tracking-wide">Template</p>
            <p className="text-sm font-medium text-text-primary">{template.name}</p>
            <p className="text-xs text-text-secondary font-mono">
              v{template.version} · {template.total_questions} questions
            </p>
          </div>

          <p className="text-sm text-text-secondary">
            This template includes content provided through VeriGRC. Your use, modification, and any
            content you add remain subject to the applicable template license and the VeriGRC platform
            terms. Your organization is responsible for complying with those terms and any rights it
            holds in content it adds.
          </p>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isPending}>
            Cancel
          </Button>
          <Button onClick={() => onConfirm(template)} disabled={isPending}>
            {isPending ? 'Importing…' : 'Confirm Import'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
